var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountDetailIconActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.92652 0C3.09254 0 1.60156 1.49098 1.60156 3.32496C1.60156 5.12393 3.00854 6.57991 4.84252 6.64291C4.89852 6.63591 4.95452 6.63591 4.99652 6.64291C5.01052 6.64291 5.01752 6.64291 5.03152 6.64291C5.03852 6.64291 5.03852 6.64291 5.04552 6.64291C6.83749 6.57991 8.24447 5.12393 8.25147 3.32496C8.25147 1.49098 6.76049 0 4.92652 0Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.48386 8.50481C6.53089 7.20282 3.34596 7.20282 1.37898 8.50481C0.489994 9.0998 0 9.90479 0 10.7658C0 11.6268 0.489993 12.4248 1.37198 13.0127C2.35197 13.6707 3.63992 13.9997 4.92791 13.9997C6.21589 13.9997 7.50387 13.6707 8.48386 13.0127C9.36585 12.4178 9.85584 11.6198 9.85584 10.7518C9.84884 9.89079 9.36585 9.0928 8.48386 8.50481Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountDetailIconActive);
export default __webpack_public_path__ + "static/media/account_detail_icon_active.198f47290236eb322004e6f27e575efd.svg";
export { ForwardRef as ReactComponent };